import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { useQuery } from 'react-query'
import { SandboxStatsResponse } from 'interfaces/sandbox'

const fetchSandboxStats = async (): Promise<SandboxStatsResponse> => {
  const response = await fetch(`${BASE_API_URL}/admin/api/v4/sandboxes/stats`, {
    method: API_METHODS.GET,
    headers: apiHeaders(store.getState()),
  })
  const handledResponse = handleErrors(response)
  return handledResponse.json()
}

const useGetSandboxStats = () => {
  return useQuery(['sandbox-stats'], () => fetchSandboxStats(), {
    refetchOnWindowFocus: false,
    staleTime: 60000,
  })
}

export default useGetSandboxStats
